{
  "settings": "Stillingar",
  "yourDigitalAssistant": "Stafræni aðstoðarmaðurinn þinn",
  "getStarted": "Byrja",
  "login": "Skrá inn",
  "loggingIn": "Innskráning ...",
  "darkMode": "Myrkur háttur",
  "clearHistory": "Hreinsa söguna",
  "historyCleared": "Sagan hreinsuð",
  "changeLanguage": "Tungumál",
  "termsAndConditions": "Notenda Skilmálar",
  "messagePlaceholder": "Sláðu inn skilaboðin þín hér ...",
  "messagePlaceholderDisabled": "Vélritun óvirk ...",
  "feedbackTitle": "Gefðu reynslu þinni einkunn",
  "feedbackPlaceholder": "Segðu okkur frá því (valfrjálst)",
  "feedbackSend": "Send",
  "feedbackClose": "Lokaðu",
  "sessionExpired": "Þingið þitt er útrunnið vegna óvirkni.",
  "startNewSession": "Byrjaðu nýja setu",
  "apiError": "Úbbs! Eitthvað fór úrskeiðis. Við erum að vinna í því að laga þetta eins fljótt og við getum.",
  "apiErrorOffline": "Þú ert ekki nettengdur.",
  "tryAgain": "Reyndu aftur",
  "startOver": "Byrja aftur",
  "chatEnded": "Spjallinu er lokið.",
  "chatEndedThankYou": "Þakka þér fyrir að spjalla við okkur!",
  "closeChat": "Lokaðu",
  "startNewChat": "Spjallaðu aftur",
  "humanTakeoverStarted": "Nú er verið að flytja þig í þjónustu við viðskiptavini ...",
  "humanTakeoverQueued": "Bið eftir að tengjast umboðsmanni",
  "humanTakeoverAnAgent": "Umboðsmaður",
  "humanTakeoverAgentEntered": "kom inn í samtalið",
  "humanTakeoverAgentLogout": "yfirgaf samtalið",
  "humanTakeoverTransfer": "Þú ert að flytja til nýs umboðsmanns",
  "humanTakeoverEnded": "Þú ert nú að spjalla við stafræna aðstoðarmanninn þinn",
  "version": "Útgáfa",
  "formIntroText": "Vinsamlegast fyllið eftirfarandi eyðublað til að byrja að spjalla við okkur.",
  "formFirstName": "Fyrsta nafn",
  "formLastName": "Eftirnafn",
  "formName": "Nafn",
  "formEmail": "Tölvupóstur",
  "formWrongEmail": "Vinsamlegast gefðu upp gilt netfang.",
  "formPhone": "Sími",
  "formShipmentId": "Sendingarkenni",
  "formQuestion": "Spurningin þín",
  "formAccountNumber": "Reikningsnúmer (fyrir viðskiptavini)",
  "formAddress": "Heimilisfang",
  "formPostcode": "Póstnúmer",
  "formCity": "Borg",
  "formCountry": "Land",
  "formSubmitButton": "Byrjaðu spjall",
  "formEmptyFieldError": "Ekki leyfilegt að vera tómur.",
  "formPhoneNumberValidationError": "Ekki gilt símanúmer.",
  "formInputIsBiggerThan50": "Verður að vera í mesta lagi 50 stafir.",
  "formInputIsBiggerThan100": "Verður að vera í mesta lagi 100 stafir.",
  "formInputIsBiggerThan2000": "Verður að vera í mesta lagi 2000 stafir.",
  "widgetEventOnline": "DA skilaboð: Notandi er kominn aftur á netið.",
  "widgetEventHidden": "DA skilaboð: Búnaður er falinn.",
  "widgetEventVisible": "DA skilaboð: Búnaður er sýnilegur.",
  "widgetEventVisibleMinimized": "DA skilaboð: Búnaður er sýnilegur en lágmarkaður.",
  "widgetEventMinimized": "DA skilaboð: Búnaður er lágmarkaður.",
  "widgetEventMaximized": "DA skilaboð: Búnaður er hámarkaður.",
  "widgetEventSessionExpired": "DA skilaboð: Búnaðarfundur rann út.",
  "widgetEventHangupHuman": "DA skilaboð: Notandi lýkur yfirtöku fundar.",
  "widgetEventUserTyping": "DA skilaboð: Notandi er að skrifa.",
  "fileTooLarge": "Þú ert að reyna að hengja við of stórar skrár.",
  "tooManyDiles": "Þú ert að reyna að hengja við of margar skrár.",
  "fileInvalidType": "Þú ert að reyna að hengja við ógildar tegundir skráa.",
  "attachmentsDropHere": "Sendu hingað til að hlaða inn eða",
  "attachmentsBrowse": "Vafra um skrár",
  "attachmentsExtenstionQuantity": "pdf eða myndir (allt að 10 skrár)",
  "attachmentsSize": "allt að 30 MB",
  "attachmentsFailedUploading": "Upphleðsla mistókst",
  "attachmentsUploading": "Hleður inn ...",
  "minimizeExpandText": "Lifandi spjall við okkur núna!",
  "popupWidgetNotificationMessage": "Þú fékkst ný skilaboð!",
  "tabWidgetNotificationMessage": "Ný skilaboð!",
  "datepickerSendButton": "Senda"
}
